import React from "react";

import { DataTable } from "primereact/datatable";
import { Column } from "primereact/column";
import { Button } from "primereact/button";
import { Toolbar } from "primereact/toolbar";
import { Dropdown } from "primereact/dropdown";

import { formatDate } from "../../js/utils";

import "../../css/candidate-table.css";

const GenderFilterTemplate = ({ genderFilter, tableRef, genders }) => {
  return (
    <Dropdown
      className={"gender-filter-dropdown"}
      options={genders}
      value={genderFilter.value}
      optionLabel="Description"
      dataKey="Description"
      style={{ width: "150PX", padding: "0px" }}
      placeholder="Select"
      showClear={true}
      onChange={e =>
        genderFilter.onChange(e, tableRef, genderFilter.filterName)
      }
    />
  );
};

const StandardColumnTemplate = (rowData, field, goToCandidate) => {
  return (
    <div
      className={"click-column"}
      onClick={e => {
        goToCandidate(rowData);
      }}
    >
      <span>{rowData[field]}</span>{" "}
    </div>
  );
};

const ModifiedDateTemplate = (rowData, goToCandidate) => {
  return (
    <div
      className={"click-column"}
      onClick={e => {
        goToCandidate(rowData);
      }}
    >
      <span>{formatDate(rowData["ModifiedDate"])}</span>
    </div>
  );
};

const CandidateTableFooter = ({
  tableRef,
  selectedRows,
  exportExcel,
  exportPdf
}) => {
  return (
    <Toolbar>
      <div className="p-toolbar-group-left">
        <Button
          type="button"
          icon="pi pi-external-link"
          iconPos="left"
          label="Export to Excel"
          onClick={() => exportExcel(tableRef, selectedRows)}
          style={{margin:10, fontWeight:"bold"}} 
        />
        <Button
          id="exportToPDFInTable"
          type="button"
          icon="pi pi-external-link"
          iconPos="left"
          label="Export to PDF"
          onClick={() => exportPdf(tableRef, selectedRows)}
          style={{margin:10,fontWeight:"bold"}} 
        />
      </div>
    </Toolbar>
  );
};

const CandidateTable = ({
  candidates,
  tableRef,
  exportExcel,
  exportPdf,
  isAdmin,
  isGovernment,
  selectedRows,
  goToCandidate,
  genderFilter,
  genders
}) => {
  let footer = (
    <CandidateTableFooter
      tableRef={tableRef}
      exportExcel={exportExcel}
      exportPdf={exportPdf}
      selectedRows={selectedRows.value}
    />
  );
  let genderFilterTemplate = (
    <GenderFilterTemplate
      genderFilter={genderFilter}
      tableRef={tableRef}
      genders={genders}
    />
  );

  let columnDefinitions = [
    { field: "selection", selectionMode: "multiple", style: { width: "3em" } },
    {
      field: "GivenNames",
      header: "First Name",
      sortable: true,
      filter: true,
       style:{width:"200px"}
    },
    {
      field: "FamilyName",
      header: "Last Name",
      sortable: true,
      filter: true,
      style:{width:"200px"}
    },
    { field: "Email", header: "Email", sortable: true, filter: true, style:{width:"300px"} },
    {
      field: "GenderDescription",
      header: "Gender",
      sortable: true,
      filter: true,
      style:{width:"180px"},
      filterElement: genderFilterTemplate
    },
    {
      field: "ModifiedDate",
      header: "Last Updated",
      sortable: true,
      filter: false,
      style:{width:"180px"},
      body: rowData => {
        return ModifiedDateTemplate(rowData, goToCandidate);
      }
    }
  ];

  let columns = columnDefinitions.map(col => {
    return (
      <Column
        {...col}
        key={col.field}
        body={rowData =>
          col.body
            ? col.body(rowData)
            : StandardColumnTemplate(rowData, col.field, goToCandidate)
        }
        filterMatchMode="contains"
        
      />
    );
  });

  return (
    <React.Fragment>
      {(isAdmin || isGovernment) && (
        <DataTable
          value={candidates}
          paginator={true}
          rows={20}
          footer={footer}
          responsive={true}
          selection={selectedRows.value}
          resizableColumns={false}
          onSelectionChange={e =>
            selectedRows.onChange(e, selectedRows.propertyName)
          }
          className="candidate-table p-datatable-hoverable-rows"
          ref={tableRef}
        >
          {columns}
        </DataTable>
      )}
    </React.Fragment>
  );
};

export default CandidateTable;



// WEBPACK FOOTER //
// ./src/components/candidate/candidate-table.js